import { getTimezone } from '@shared/createEvent/utils/getTimezone';
import { createTelemetry, createTelemetryObject } from '@shared/core';
import { PageFunctionType } from '@shared/core/analytics/telemetry/types';
import { CREATE_CTA, category } from './constants';

type PagesForTelemetry = 'createAccount' | 'socialAccount' | 'createBabyRegistryForm' | 'tyingTheKnot';

const pageTracking: Record<PagesForTelemetry, PageFunctionType> = {
  createAccount: () => ({ category, page: 'signup', pagePrefix: 'marketing' }),
  socialAccount: () => ({ category, page: 'social_intercept', pagePrefix: 'marketing' }),
  createBabyRegistryForm: () => ({ category, page: 'babyRegistryForm', pagePrefix: 'marketing' }),
  tyingTheKnot: () => ({ category, page: 'tyingTheKnot', pagePrefix: 'marketing' })
};

export const createBabyRegistryTelemetry = createTelemetryObject({
  actions: {
    trackError: (action: string, error: unknown) => ({ action, actionType: 'error', category, extraInfo: { error } }),
    dateSet: (eventDate: string, dateLabel: string) => ({ action: 'DateSet', category, label: dateLabel, extraInfo: { eventDate } }),
    timezoneRegistered: (info: ReturnType<typeof getTimezone>) => ({ action: 'TimezoneRegistered', category, extraInfo: info }),
    submitDetailsClicked: (userEmail: string) => ({
      action: CREATE_CTA,
      actionType: 'click',
      label: 'Create Baby Registry',
      category,
      extraInfo: { email: userEmail, CtaName: 'CreateBabyCTA' }
    }),
    joyEventCreated: (website: string, eventId: string, email?: string) => ({ action: 'Publish', label: website, category, extraInfo: { eventId, email, orderId: Date.now() } }),
    registryOwnerFirstNameClicked: () => ({ action: 'BabyRegistryOwnerFirstName', actionType: 'click', category }),
    registryOwnerLastNameClicked: () => ({ action: 'BabyRegistryOwnerLastName', actionType: 'click', category }),
    registryNameClicked: () => ({ action: 'BabyRegistryName', actionType: 'click', category }),
    dateSelected: () => ({ action: 'Date', actionType: 'select', category }),
    dateUndecidedClicked: () => ({ action: 'DateUndecided', actionType: 'click', category })
  },
  pages: pageTracking
});

const { TelemetryProvider, useTelemetry: useCreateBabyRegistryTelemetry } = createTelemetry(createBabyRegistryTelemetry);

export { TelemetryProvider, useCreateBabyRegistryTelemetry };
